// eslint-disable-next-line import/no-anonymous-default-export

import React, { useState, useEffect, useRef } from 'react';
import { SelectBox, CheckBox } from 'devextreme-react';
import DOMPurify from 'dompurify';
import { MapContainer, ImageOverlay, Polygon } from 'react-leaflet';
import L from "leaflet";
import "leaflet.heat";
import "leaflet/dist/leaflet.css";
import DataGrid, {
  Column,
  Paging,
  FilterRow,
  HeaderFilter,
  Selection,
  FilterPanel
} from 'devextreme-react/data-grid';
import {
  Chart, CommonSeriesSettings, Legend, SeriesTemplate, ArgumentAxis, ValueAxis, Tick, Size
} from 'devextreme-react/chart';
import moment from 'moment-timezone';
import { CRS, latLngBounds } from 'leaflet';
import 'leaflet/dist/leaflet.css'
import AssetsService from 'api/assets.service';
import SpacesService from 'api/spaces.service';
import { DateBox } from 'devextreme-react/date-box';
import './utilization.css';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

const UtilizationHeatMapMultiple = (props) => {
  const listRef = useRef();
  const dropDataGridUtilRef = useRef();
  const tenant = props.tenant;
  const [floorplan, setFloorplan] = useState("");
  const [heatmapData, setHeatMapData] = useState([]);
  const [totalDistance, setTotalDistance] = useState(0);
  const [data, setData] = useState([]);
  const [motionBarChart, setMotionBarChart] = useState([]);
  const [spaces, setSpaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingText, setLoadingText] = useState('Loading...');
  const [isMotion, setIsMotion] = useState(true);
  const [isStationary, setIsStationary] = useState(true);
  const [selectedSpaceItem, setSelectedSpaceItem] = useState(null);
  const [selectedSpaceItemName, setSelectedSpaceItemName] = useState(null);
  const [height, setHeight] = useState(200);
  const [utilizationPercent, setUtilizationPercent] = useState(0);
  const [utilizationText, setUtilizationText] = useState('0 minutes');
  const [unitValue, setUnitValue] = useState('');
  const [bounds, setBounds] = useState(new latLngBounds([0, 0], [25, 35]));
  const [center, setCenter] = useState([0, 0]);
  const [showMotionStationaryErrorMsg, setShowMotionStationaryErrorMsg] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedValue, setSelectedValue] = useState('Last 24 hours');
  const [multipleAssetData, setMultipleAssetData] = useState([])
  const [heatmapLoading, setHeatmapLoading] = useState(true);
  const [heatmapError, setHeatmapError] = useState(null);
  const [retryCount, setRetryCount] = useState(0);
  const dateBoxRefStartUtil = useRef(null);
  const dateBoxRefEndUtil = useRef(null);
  const [zoom, setZoom] = useState(2)
  const [max, setMax] = useState(0)
  const [floorplanHeight, setFloorplanHeight] = useState(0)
  const [floorplanWidth, setFloorplanWidth] = useState(0)
  
  const PE_TENANT_ID = '964f8b8d-14a6-40f9-9b6f-c7614e1238a0'
  useEffect(async () => {
    if(loading) {
      if (props.spaces.length>0) {
        setLoading(false);
        setTimeout(async() => {
          setHeight('100%');
            await setSpaces(props.spaces);
            await setSelectedSpaceItem(props.spaces[0].id)
            await setSelectedSpaceItemName(props.spaces[0].name)
        }, 200);
        // getDateRangeFromLocalStorage();
      }
    }
  }, [loading, props.spaces]);

  useEffect(async () => {
    setLoading(true);
  }, [props.dateRange]);


  useEffect(() => {
    // Retrieve data from localStorage
    const storedData = localStorage.getItem(`multiple-asset-selection-ids-${tenant}`);
    if (storedData) {
        setMultipleAssetData(JSON.parse(storedData));
    }
    // getData()
  }, []);

  

  function secondsToText(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    // const remainingSeconds = seconds % 60;
    let result = "";
    if (hours > 0) {
      result += hours + " hour" + (hours > 1 ? "s" : "") + " ";
    }
    if (minutes > 0) {
      result += minutes + " minute" + (minutes > 1 ? "s" : "") + " ";
    }
    if (result === '') result = `${seconds} seconds`
    return result;
  }
  const getAssetUtilizationHeatMap = async () => {
    try {
      setHeatmapLoading(true);
      setHeatmapError(null);
      setLoadingText('Loading...')
      setHeatMapData([])
      setFloorplan(null)
      
      if (selectedSpaceItem === null) {
        setHeatmapLoading(false);
        return null;
      }
      
      if (!isStationary && !isMotion) {
        setHeatmapLoading(false);
        return null;
      }
      
      const from = moment(localStorage.getItem(`${tenant}dateFilterFrom`)).utc().format();
      const to = moment(localStorage.getItem(`${tenant}dateFilterTo`)).utc().format();
      
      if (selectedSpaceItem === null) return null; // if nothing is selected from floorplans
      if (!isStationary && !isMotion) return null;
      
      setHeight('100%');
      
      const result = await AssetsService.getMultipleAssetUtilizationHeatMap(
        multipleAssetData,
        selectedSpaceItem,
        from,
        to,
        isMotion,
        isStationary
      );
      
      if(result.data.status===200) {
        const response = result.data.data;
        setUtilizationText(secondsToText(response.totalDurationInSeconds))
        setUnitValue(response.unit)
        setHeatMapData(response.mapData);
        setMax(response.maxValue);
        
        if(response?.mapData?.length > 0){
          setHeight('100%');
          
          // Load floorplan
          try {
            const res = await SpacesService.getSpaceFloorplan(selectedSpaceItem);
            let myFloorplan = URL.createObjectURL(res.data)
            setFloorplan(myFloorplan)
          } catch (error) {
            console.error('Error loading floorplan:', error);
          }
          
          // setting zoom
          if (listRef && listRef.current){
            let s = listRef.current.clientWidth
            if (listRef.current.clientHeight < s) {
                s = listRef.current.clientHeight
            }
            let z = (Math.log(s / 15.625) / Math.log(2)) - 1.5
            setZoom(z)
          }
          
          // Get space bounds
          try {
            const res2 = await SpacesService.getSpace(selectedSpaceItem);
            let response2 = res2.data
            let refSpaceBounds = response2.data.localCoordinates
            let correctedRefSpaceBounds = []
            for (let i = 0; i < refSpaceBounds.length; i++) {
                correctedRefSpaceBounds.push([refSpaceBounds[i][1], refSpaceBounds[i][0]])
            }
            let coords = correctedRefSpaceBounds
            let xMax = 0
            let yMax = 0
            for (let i = 0; i < coords.length; i++) {
                if (coords[i][0] > xMax) {
                    xMax = coords[i][0]
                }
                if (coords[i][1] > yMax) {
                    yMax = coords[i][1]
                }
            }
            setFloorplanWidth(xMax)
            setFloorplanHeight(yMax)
            setBounds(new latLngBounds([0, 0], [xMax, yMax]))
            setCenter([0 + xMax / 2, 0 + yMax / 2])
          } catch (error) {
            console.error('Error loading space bounds:', error);
          }
          
          const duration = moment.duration(moment(to).diff(from));
          const diff = duration.asSeconds();
          const utilizationPercentage = Math.round(((response.totalDurationInSeconds / diff) * 100));
          setUtilizationPercent(utilizationPercentage);
        } else {
          setLoadingText('No Data')
        }
      }
    } catch (error) {
      console.error('Error loading heat map:', error);
      setHeatMapData([]);
      setFloorplan(null);
      setLoadingText('Error loading data');
      setHeatmapError(`Failed to load heat map: ${error.message}`);
      setRetryCount(prev => prev + 1);
    } finally {
      setHeatmapLoading(false);
    }
  }

  const getMultipleAssetUtilizationChart = async () => {
    setMotionBarChart([])
    const from = moment(localStorage.getItem(`${tenant}dateFilterFrom`)).utc().format();
    const to = moment(localStorage.getItem(`${tenant}dateFilterTo`)).utc().format();
    if (selectedSpaceItem === null) return null; // if nothing is selected from floorplans
    if (!isStationary && !isMotion) return null;
    setHeight('100%');
    await AssetsService.getMultipleAssetUtilizationChart(
      multipleAssetData,
      selectedSpaceItem,
      from,
      to,
      isMotion,
      isStationary
    ).then(async (result) => {
      if(result.data.status===200) {
        const response = result.data.data;
            await response.timeGraphData.forEach(function(result) {
              result.start = new Date(result.start);
              result.end = new Date(result.end);
            });
            setMotionBarChart(response.timeGraphData);
        }else {
          setLoadingText('No Data')
        }
      })
    }

  const getAssetUtilizationDataGrid = async () => {
    setData([])
    setTotalDistance(0)
    const from = moment(localStorage.getItem(`${tenant}dateFilterFrom`)).utc().format();
    const to = moment(localStorage.getItem(`${tenant}dateFilterTo`)).utc().format();
    if (selectedSpaceItem === null) return null; // if nothing is selected from floorplans
    if (!isStationary && !isMotion) return null;
    setHeight('100%');
    await AssetsService.locationHistoryMultiple(multipleAssetData, from, to, selectedSpaceItem).then((value) => {
      if (value.data.status === 200){
        setData(value.data.data.history);
        setTotalDistance(value.data.data.totalDistance);
      } else {
        setLoadingText('No Data')
      }
    })
  }

  const onFloorplanChange = async (event) => {
    await setSelectedSpaceItem(event.value);
  }


  const getFloorPlans = async() => {
    resetData()
    const from = moment(localStorage.getItem(`${tenant}dateFilterFrom`)).utc().format();
    const to = moment(localStorage.getItem(`${tenant}dateFilterTo`)).utc().format();
    if (from === "Invalid date" || to === "Invalid date") return true;
    AssetsService.locationHistoryMultiple(multipleAssetData, from, to).then((response) => {
      if (response?.data?.data?.floorplans?.length > 0) {
        setSelectedSpaceItem(response.data.data.floorplans[0].id);
        setSelectedSpaceItemName(response.data.data.floorplans[0].name);
        setSpaces(response.data.data.floorplans);
        getAssetUtilizationHeatMap(selectedSpaceItem)
        getAssetUtilizationDataGrid(selectedSpaceItem)
        getMultipleAssetUtilizationChart(selectedSpaceItem)
      } else {
        setSelectedSpaceItem(null);
        setSelectedSpaceItemName(null);
        setSpaces([]);
        setLoadingText("No Data")
        setMotionBarChart([])
        setData([])
        setHeatMapData([])
        setTotalDistance(0)
        setFloorplan(null)
        setHeatmapLoading(false);
      }
    })
  };

  const OnMotionChange = async(motion) => {
    if(motion === 'isMotion') {
      await setIsMotion(!isMotion);
    } else if(motion === 'isStationary') {
      await setIsStationary(!isStationary);
    }
  };

  useEffect(() => {
    // Fetch data when the component mounts
    if (multipleAssetData.length > 0) {
      getFloorPlans();
    }
  }, [multipleAssetData.length]);

  async function resetData(){
    setUtilizationPercent(0)
    setHeatMapData([])
    setMotionBarChart([])
    setSpaces([])
    setData([])
    setFloorplan("")
    setUtilizationText("0 minutes")
    setTotalDistance(0)
  }

  const handleValueChange = async (value) => {
    await resetData();
    setSelectedValue(value);
    if (value === 'Custom') {
      // setIsDisabled(false)
      localStorage.setItem(`${tenant}dateFilterText`, value);
    } else {
      setStartDate(null);
      setEndDate(null);
      let start, end;
      switch (value) {
        case 'Last 24 hours':
          start = moment().subtract(24, 'hours').format();
          end = moment().format();
          break;
        case 'Today':
          start = moment().startOf('day').format();
          end = moment().endOf('day').format();
          break;
        case 'Last 5 min':
          start = moment().subtract(5, 'minutes').format();
          end = moment().format();
          break;
        case 'Last 20 min':
          start = moment().subtract(20, 'minutes').format();
          end = moment().format();
          break;
        case 'Last 1 hour':
          start = moment().subtract(1, 'hour').format();
          end = moment().format();
          break;
        case 'Last 4 hours':
          start = moment().subtract(4, 'hours').format();
          end = moment().format();
          break;
        case 'Last 12 hours':
          start = moment().subtract(12, 'hours').format();
          end = moment().format();
          break;
        case 'Yesterday':
          start = moment().subtract(1, 'day').startOf('day').format();
          end = moment().subtract(1, 'day').endOf('day').format();
          break;
        case 'This Week':
          start = moment().startOf('week').format();
          end = moment().endOf('week').format();
          break;
        case 'Last Week':
          start = moment().subtract(1, 'weeks').startOf('week').format();
          end = moment().subtract(1, 'weeks').endOf('week').format();
          break;
        case 'This Month':
          start = moment().startOf('month').format();
          end = moment().endOf('month').format();
          break;
        case 'Last Month':
          start = moment().subtract(1, 'month').startOf('month').format();
          end = moment().subtract(1, 'month').endOf('month').format();
          break;
        case 'Last 7 days':
          start = moment().subtract(7, 'days').format();
          end = moment().format();
          break;
        default:
          break;
      }
      console.log('start: ', start, ',end: ', end);
      setStartDate(start);
      setEndDate(end);
      localStorage.setItem(tenant + "dateFilterText", `${value}`)
    }
  };

  function onMounted(num) {
    if (document.querySelector('.leaflet-draw-section .leaflet-draw-toolbar.leaflet-bar.leaflet-draw-toolbar-top') !== null) {
      {
        document.querySelector('.leaflet-draw-section .leaflet-draw-toolbar.leaflet-bar.leaflet-draw-toolbar-top').style.setProperty('--thumb-width', 'hidden');
        document.querySelector('.leaflet-draw.leaflet-control').style.setProperty('--display', 'flex');
        document.querySelector('.leaflet-draw.leaflet-control').style.setProperty('--margin', '0px');
      }
    }
  }

  const bands = [
    { max: 1 / 60, color: '#BA8DC1' }, // 0-1 min
    { max: 5 / 60, color: '#99D5FF' },
    { max: 15 / 60, color: '#79DE85' },
    { max: 1, color: '#FFFF00' },
    { max: 6, color: '#FEB800' },
    { max: 24, color: '#FF0000' },
  ];

  function getColorFromBand(hoursPerDay) {
    for (let band of bands) {
      if (hoursPerDay <= band.max) return band.color;
    }
    return 'red';
  }

  function normalizeHeatmapData(rawData, totalDays) {
    const grid = {};
    rawData.forEach(({ lat, lng, value }) => {
      const x = Math.floor(lng);
      const y = Math.floor(lat);
      const key = `${x},${y}`;
      grid[key] = (grid[key] || 0) + value;
    });
  
    return Object.entries(grid).map(([key, totalSeconds]) => {
      const [x, y] = key.split(',').map(Number);
      const hoursPerDay = (totalSeconds / 3600) / totalDays;
      return { x, y, color: getColorFromBand(hoursPerDay) };
    });
  }


  const legendBoxStyle = (bgColor) => ({
    backgroundColor: bgColor,
    padding: '6px 10px',
    width: '100px',
    color: '#000',
    fontSize: '12px',
    textAlign: 'center',
    borderRadius: '4px',
  });

  function HeatmapGridOverlay({ floorplanUrl, rawData, startDate, endDate }) {
    // const bounds = [[0, 0], [floorplanHeight, floorplanWidth]];
    const totalDays = (new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24);
  
    const normalizedGrid = normalizeHeatmapData(rawData, totalDays);
  
    return (
      <>
      <MapContainer
        id="map"
        // crs={L.CRS.Simple}
        crs={CRS.Simple}
        bounds={bounds}
        style={{ height: '500px', width: '100%' }}
        maxZoom={7}
        zoomSnap={0}
        zoomControl={true}
      >
         {heatmapLoading && (
            <div className='noDataHeatMap'>
              <p>Loading heat map...</p>
            </div>
          )}
         {!heatmapLoading && !heatmapError && heatmapData?.length === 0 && (
            <div className='noDataHeatMap'>
              <p>{loadingText}</p>
            </div>
          )}
        {/* <ImageOverlay url={floorplanUrl} bounds={bounds} opacity={1} /> */}
        {floorplan && <ImageOverlay url={floorplanUrl} bounds={bounds} opacity={1} />}

        {heatmapData?.length > 0 && (
          normalizedGrid.map(({ x, y, color }, idx) => {
          const w = x === Math.floor(floorplanWidth) ? floorplanWidth - x : 1;
          const h = y === Math.floor(floorplanHeight) ? floorplanHeight - y : 1;
  
          return (
            <Polygon
              key={idx}
              positions={[
                [y, x],
                [y, x + w],
                [y + h, x + w],
                [y + h, x],
              ]}
              pathOptions={{ fillColor: color, fillOpacity: 0.6, stroke: false }}
            />
          );
        })
      )}
            {heatmapData?.length > 0 && (
            <div
              style={{
                position: 'absolute',
                bottom: '20px',
                right: '20px',
                zIndex: 1000,
                backgroundColor: 'white',
                borderRadius: '4px',
                opacity: 0.9,
              }}
              >
              <div style={{
                  position: 'absolute',
                  bottom: '10px',
                  right: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  zIndex: 1000,
                  backgroundColor: 'white',
                  padding: '8px',
                  borderRadius: '6px',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                  height: 'fit-content'
                }}>
                {/* Vertical Label */}
                <div style={{
                  writingMode: 'vertical-rl',
                  transform: 'rotate(180deg)',
                  fontWeight: '600',
                  fontSize: '12px',
                  textAlign: 'center',
                  marginRight: '10px',
                  lineHeight: '1.2',
                  whiteSpace: 'nowrap'
                }}>
                  Average Utilization per Day
                </div>
 
                {/* Color Legend Bars */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <div style={legendBoxStyle('#BA8DC1')}>0 - 1 min</div>
                  <div style={legendBoxStyle('#99D5FF')}>1 - 5 min</div>
                  <div style={legendBoxStyle('#79DE85')}>5 - 15 min</div>
                  <div style={legendBoxStyle('#FFFF00')}>15 - 60 min</div>
                  <div style={legendBoxStyle('#FEB800')}>1 - 6 hours</div>
                  <div style={legendBoxStyle('#FF0000')}>6 - 24 hours</div>
                </div>
              </div>

            </div>
            )}
      </MapContainer>
      
     </>
    );
  }

  const handleStartDateUtil = () => {
    dateBoxRefStartUtil.current.instance().open();
    setSelectedValue("Custom")
  }

  const handleEndDateUtil = () => {
    dateBoxRefEndUtil.current.instance().open();
    setSelectedValue("Custom")
  }

  const handleStartDateChange = async (value) => {
    await setStartDate(value);
    if (value && endDate && moment(value).isAfter(endDate)) {
      await setEndDate(moment(value).add(1, 'days').toDate());
      localStorage.setItem(`${tenant}dateFilterTo`, moment(value).add(1, 'days').toDate())
    }
    localStorage.setItem(`${tenant}dateFilterFrom`, moment(value).format())

    if (endDate) {
      localStorage.setItem(`${tenant}dateFilterTo`, moment(endDate).format());
    }
    getFloorPlans()
  };

  const handleEndDateChange = async (value) => {
    await setEndDate(value);
    if (value && startDate && moment(value).isBefore(startDate)) {
      await setStartDate(moment(value).subtract(1, 'days').toDate());
      localStorage.setItem(`${tenant}dateFilterFrom`, moment(value).subtract(1, 'days').toDate())
    }
    localStorage.setItem(`${tenant}dateFilterTo`, moment(value).format())
    if (startDate) {
      localStorage.setItem(`${tenant}dateFilterFrom`, moment(startDate).format());
    }
    getFloorPlans()
  };

  useEffect(() => {
    if (!isStationary && !isMotion){
      setShowMotionStationaryErrorMsg(true)
    } else if (selectedSpaceItem && startDate && endDate && multipleAssetData.length > 0) {
      setShowMotionStationaryErrorMsg(false)
      getAssetUtilizationHeatMap()
    }
  }, [isMotion, isStationary, selectedSpaceItem, startDate, endDate, multipleAssetData.length]);

  useEffect(() => {
    if (selectedSpaceItem && startDate && endDate && multipleAssetData.length > 0) {
      getFloorPlans()
    }
  }, [selectedSpaceItem, startDate, endDate, multipleAssetData.length]);

  useEffect(() => {
    if (startDate && endDate) {
      getFloorPlans();
    }
  }, [startDate, endDate]);
  
  // Ensure heat map is loaded when all required dependencies are available
  useEffect(() => {
    if (selectedSpaceItem && startDate && endDate && (isMotion || isStationary) && multipleAssetData.length > 0) {
      console.log('All dependencies available, loading heat map...');
      getAssetUtilizationHeatMap();
    }
  }, [selectedSpaceItem, startDate, endDate, isMotion, isStationary, multipleAssetData.length]);

  useEffect(() => {
    // Only proceed if component is properly mounted and spaces are available
    if (props.selectedTabIndex !== undefined) {
      const periodVal = localStorage.getItem(`${tenant}dateFilterText`);
      if (periodVal !== null && periodVal !== 'null') {
        console.log('period val: ', periodVal);
        if (periodVal === 'Custom') {
          const startDate = moment(localStorage.getItem(`${tenant}dateFilterFrom`));
          const endDate = moment(localStorage.getItem(`${tenant}dateFilterTo`));
          setStartDate(startDate);
          setEndDate(endDate);
        }
        handleValueChange(periodVal);
      } else {
        handleValueChange('Last 24 hours')
      }
    }
  }, [props.selectedTabIndex, props.spaces.length]); // Add proper dependencies


  const customizeSeries = (deviceMotion) => {
    if(deviceMotion === 'Motion') {
      return { color: '#FFC001'};
    }
    return { color: '#CCCCCC'};
  };

  const customizeTextLegend = (item) => {
    // return item.seriesName === 'noMotion' ? 'No Motion' : item.seriesName;
    return item.seriesName === 'noMotion' ? 'No Utilization' : 'Utilization';
  }

  function exportGridUtilization(e) {
    const workbook = new Workbook(); 
    const worksheet = workbook.addWorksheet("Utilization");
    const startDateGrid = moment(localStorage.getItem(`${tenant}dateFilterFrom`));
    const endDateGrid = moment(localStorage.getItem(`${tenant}dateFilterTo`));
    const startTime = new Date(startDateGrid).toLocaleString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    })
    const endTime = new Date(endDateGrid).toLocaleString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    })
    let names = localStorage.getItem(`multiple-asset-selection-records-${tenant}`)
    names = JSON.parse(names).map((item) => item.name).join(',');

    worksheet.insertRow(1, ['','','','Asset Name', names]);
    worksheet.insertRow(2, ['','','','Date Range', `${startTime} - ${endTime}`]);
    worksheet.insertRow(3, ['','','','Total Distance', totalDistance]);
    worksheet.insertRow(4, ['','','','Total Motion Time', utilizationText]);
    worksheet.insertRow(5, ['','','','Floorplan', selectedSpaceItemName]);
    worksheet.columns = [
          { width: 5 },
          { width: 30 },
          { width: 25 },
          { width: 15 },
          { width: 25 },
          { width: 40 },
        ];
    exportDataGrid({
          component: dropDataGridUtilRef.current.instance,
          worksheet,
          keepColumnWidths: false,
          topLeftCell: { row: 7, column: 1 },
          customizeCell: ({ gridCell, excelCell }) => {
            console.log('gridcell', gridCell);
            console.log('excelCell', excelCell);
            if (gridCell.rowType === 'data') {
              if (gridCell.column.dataField === 'time') {
                excelCell.value = new Date(excelCell.value).toLocaleString('en-US', {
                  weekday: 'short',
                  year: 'numeric',
                  month: 'short',
                  day: '2-digit',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: true
                });
              }
            }
          },
        }).then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `Asset-Utilization-${moment().format('YYYY-MM-DD-HH-mm-ss')}.xlsx`);
          });
        })
    e.cancel = true; 
  }

  return (
    <div className='utilizationContainer' style={{display: 'block', position: 'relative', width: '100%', minHeight: height}}>
      <div className={'btnContainer'}>
      <div className='dateBtnUtilization'>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <SelectBox
              style={{ marginRight: '10px', width: '20%' }}
              dataSource={['Today', 'Last 5 min', 'Last 20 min', 'Last 1 hour', 'Last 4 hours', 'Last 12 hours', 'Last 24 hours', 'Yesterday', 'This Week', 'Last Week', 'This Month', 'Last Month', 'Last 7 days', 'Custom']}
              value={selectedValue}
              onValueChanged={(e) => handleValueChange(e.value)}
              labelMode="static"
              label="Period"
              stylingMode="outlined"
            />
            <div onClick={() => handleStartDateUtil()}>
              <DateBox
                ref={dateBoxRefStartUtil}
                style={{ marginRight: '10px'}}
                type="datetime"
                value={startDate}
                onValueChanged={async (e) => await handleStartDateChange(e.value)}
                placeholder="Start Date"
                labelMode="static"
                label="Start Date"
                stylingMode="outlined"
                displayFormat="yyyy-MM-dd HH:mm"
                valueFormat="yyyy-MM-dd HH:mm"
              />
            </div>
            <div onClick={() => handleEndDateUtil()}>
              <DateBox
                ref={dateBoxRefEndUtil}
                style={{ marginRight: '10px'}}
                type="datetime"
                value={endDate}
                onValueChanged={(e) => handleEndDateChange(e.value)}
                placeholder="End Date"
                labelMode="static"
                label="End Date"
                stylingMode="outlined"
                displayFormat="yyyy-MM-dd HH:mm"
                valueFormat="yyyy-MM-dd HH:mm"
              />
            </div>
          <SelectBox
            style={{ marginRight: '10px'}}
            labelMode="static"
            label="Floorplan"
            items={spaces}
            stylingMode="outlined"
            value={selectedSpaceItem}
            onValueChanged={onFloorplanChange}
            valueExpr="id"
            displayExpr="name"
          >
          </SelectBox>

          <div className='uploadBtnMechanicalReport'>
            <button id="generatePdfButton" alt="Export Data" title="Export Data" type="button" onClick={exportGridUtilization}>
              <img src="../icons/excelNew.svg" alt="Export Data" style={{height: "24px", width:"24px"}} />
            </button>
          </div>


          
          {/* <Button
            width={"160px"}
            height={"88%"}
            style={{marginTop: "5px",  marginRight: '10px'}}
            type="normal"
            stylingMode="outlined"
            onClick={clearSelection}
            text="Clear Filters"
            disabled={isDisabled}
          /> */}
        </div>
        </div>
      </div>
      <div style={{margin: 10}}>
        <div className="utilizationTextCheckbox">
          {/* <p>Total utilization in the selected date range: <b>{isMotion ? totalDistance.toLocaleString() : 0} metres</b> during <b>{isMotion ?  utilizationText : '0 minutes'}</b> (<b>{isMotion ? utilizationPercent : 0}% utilization</b>)</p> */}
          <p>
            Total utilization in the selected date range:&nbsp;
            {tenant !== PE_TENANT_ID ? (
              <>
                <b>{isMotion ? totalDistance.toLocaleString() : 0} metres</b> during&nbsp;
              </>
            ) : null} 
            <b>{isMotion ? utilizationText : ' 0 minutes'}</b> 
            (<b>{isMotion ? utilizationPercent : 0}% utilization</b>)
          </p>
        </div>
        <div style={{width: "70%", marginTop: "30px", marginBottom: "30px"}}>
        {motionBarChart.length ?
        <Chart animation={{"enabled":false}} dataSource={motionBarChart} barGroupPadding={0.2} rotated={true}>
          <Size
            width={'100%'}
            height={150}
          />
          <ArgumentAxis categories={['Device Motion']} label={{
              customizeText: (arg) => {
                return ''
              }
            }}
          >
            <Tick visible={false} />
          </ArgumentAxis>
          <ValueAxis
            label={{
              customizeText: (arg) => {
                return moment(arg.value).format("YYYY-MM-DD HH:mm")
              },
            }}
          />
          <CommonSeriesSettings
            type="rangeBar"
            argumentField="activity"
            rangeValue1Field="start"
            rangeValue2Field="end"
            barOverlapGroup="activity"
          >
          </CommonSeriesSettings>
          <Legend verticalAlignment="center" horizontalAlignment="left" customizeText={customizeTextLegend}/>
          <SeriesTemplate nameField="action" customizeSeries={customizeSeries} />
        </Chart> : ""}
        {/* {motionBarChart.length ?
          <div style={{ position: 'absolute', top: '13%', right: '0', transform: 'translateY(50%)', textAlign: 'right', paddingRight: '255px' }}>
              <p>{utilizationPercent}% utilization</p>
          </div> : ""} */}
        </div>
        <div style={{ position: 'relative', height: '100%', width: '100%' }}>
        {/* {floorplan && heatmapData.length > 0 && ( */}
          <HeatmapGridOverlay
            floorplanUrl={floorplan}
            rawData={heatmapData}
            startDate={startDate}
            endDate={endDate}
          />
        {/* )} */}
        {/* {heatmapData.length > 0 && (
          <div className="gradientScaleWithNumber">
            <div className="gradientScaleParent">
              <div className="gradientScale"></div>
            </div>
            <p className="leftgradiantval">0</p>
            <p className="activityMinutes">Average Hours per Day</p>
            <p className="rightgradiantval">24</p>
          </div>
        )} */}
        <div className="utilizationCheckbox">
            <CheckBox
              value={isMotion}
              text="Motion time"
              hint="Motion"
              iconSize="15"
              onValueChanged={()=>OnMotionChange('isMotion')}
            />
            <div style={{paddingTop: "10px"}}></div>
            <CheckBox
              value={isStationary}
              text="No motion time"
              hint="Stationary"
              iconSize="15"
              onValueChanged={()=>OnMotionChange('isStationary')}
            />
            <div style={{display: showMotionStationaryErrorMsg ? "block": "none", color: "#d71109"}}>
              <p>Check either or both boxes to see Utilization data</p>
            </div>
          </div>
        <div style={{paddingTop:'50px'}}>
        <DataGrid
        // onExporting={exportGridUtilization}
        height={'calc(100vh - 329px)'}
        dataSource={data}
        ref={dropDataGridUtilRef}
        columnAutoWidth={true}
        allowColumnResizing={true}
        showBorders={true}
        noDataText={loadingText}
        keyExpr="id"
      >
        {/* <Export
          enabled={true}
        /> */}
        <Selection
          mode="multiple"
          showCheckBoxesMode="none"
        />
        <FilterPanel visible={true} texts={{createFilter: '', clearFilter:'Clear Filter', filterEnabledHint: ''}}/>
        <Paging enabled={false} />
        <FilterRow visible="true" apply-filter="true" />
        <HeaderFilter visible="showHeaderFilter" />
        <Column
          allowSorting={true}
          dataField={DOMPurify.sanitize('time')}
          caption={'Date'}
          dataType="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          allowFiltering={false}
          defaultSortIndex={1}
          defaultSortOrder="desc"
          // width={"40%"}
          // fixed={true}
          hidingPriority={8}
        >
        </Column>
        <Column
          dataField={DOMPurify.sanitize('asset')}
          caption={'Asset'}
          dataType="string"
          alignment={"left"}
          // fixed={true}
        ></Column>
        <Column
          dataField={DOMPurify.sanitize('space.name')}
          caption={'Space'}
          dataType="string"
          alignment={"left"}
          // fixed={true}
        >
        </Column>
        <Column
          dataField={DOMPurify.sanitize('motion')}
          caption={'Event'}
          dataType="string"
          alignment={"left"}
          // fixed={true}
        >
        </Column>
        {/* <Column
          dataField={DOMPurify.sanitize('duration')}
          caption={'Duration'}
          dataType="string"
          alignment={"left"}
          // fixed={true}
        >
        </Column> */}
        <Column
          dataField={DOMPurify.sanitize('distance')}
          caption={'Distance [m]'}
          dataType="number"
          alignment={"left"}
          // fixed={true}
        >
        </Column>
      </DataGrid>
      </div>
        </div>
        
        
      </div>
    </div>
  );
}
export default UtilizationHeatMapMultiple;